import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import API from '../../utils/API';
import { Elements, useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

// Load Stripe.js with your publishable key
const stripePromise = loadStripe('pk_test_51Pv4UP07633HDQMOdRtZXCaGADGT8PMlmeNnY5umiQQfANcbu36A1ylmZbLUSFrZZDIHJXKfwakmpn2jSXplza9n004kaxm4gs');

const PaymentMethodForm = ({ close, orgId, clientSecret, updatePaymentMethods }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [message, setMessage] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const setSubscriptionPaymentMethod = async (paymentMethodId) => {
        console.log('paymentMethodId', paymentMethodId);
        // Attach the PaymentMethod to the subscription
        const response = await API().get(`/Organizations/${orgId}/account/customerPaymentMethods`);
        const paymentMethods = response.data;
        updatePaymentMethods(paymentMethods);
        close();
    }

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setSubmitting(true);
        const res = await stripe.confirmSetup({
            //`Elements` instance that was used to create the Payment Element
            elements,
            redirect: 'if_required'
        });

        if (res.error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            setMessage(res.error.message);
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
            const { payment_method } = res.setupIntent;
            setSubscriptionPaymentMethod(payment_method);
        }
        setSubmitting(false);
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement

                options={{ clientSecret: clientSecret }}
            />
            <div className='flex gap10 mt-20'>

                <button type="submit" className={`prim ${(!stripe || submitting) ? 'disabled' : ''}`}>
                    Submit
                </button>
                <button onClick={() => close()} className={`text ${submitting ? 'disabled' : ''}`}>Cancel</button>
            </div>
            {message && <div>{message}</div>}
        </form>
    );
};

const PaymentPage = ({ close, orgId, clientSecret, updatePaymentMethods }) => {

    const options = {
        // passing the client secret obtained in step 3
        clientSecret: clientSecret,
        // Fully customizable with appearance API.
        appearance: {/*...*/ },
    };
    return (
        <Elements stripe={stripePromise} options={options}>
            <PaymentMethodForm clientSecret={clientSecret} close={close} orgId={orgId} updatePaymentMethods={updatePaymentMethods} />
        </Elements>
    );
};

export default PaymentPage;